/** own = logged-in user changes their password; admin = privileged reset of another object */
type TPasswordPageMode = 'own' | 'admin'

interface IObservableInputs {
    old: KnockoutObservable<string>
    new: KnockoutObservable<string>
    repeat: KnockoutObservable<string>
    toggle_old: KnockoutObservable<boolean>
    toggle_new: KnockoutObservable<boolean>
    toggle_repeat: KnockoutObservable<boolean>
}

interface IGetCssStates {
    old: () => 'warning' | null
    new: () => 'warning' | null
    repeat: () => 'warning' | null
}

type TErrorTranslation = 
'not.sufficient.permissions' |
'new.password.too.short' | 
'new.password.too.long' |
'password.no.username' |
'password.complexity.fail' |
'old.password.incorrect'

interface ITranslationObject {
    serverMessage: string | RegExp
    translation: TErrorTranslation
}
